import { bannerService } from "../../helpers/bannerService";

export const state = {
  getShowBanner: [],
  getUpdateStatus: [],
  getAllChargers: [],
  getAllUsers: [],
  getAllBanner: [],
  getAllPrivateCharger: [],
  userVehicleCount: "",
  bannerCount: "",
  privateChargerCount: "",
  paginations: {},
  loading: true,
  getBookingReportByYear: {},
  getEarningReportByYear: {},
};

export const mutations = {
  getShowBanner(state, payload) {
    state.getShowBanner = payload.result;
    state.loading = false;
  },
  getUser(state, payload) {
    state.getAllUsers = payload.result;
  },
  getBookingReportByYear(state, payload) {
    var result = [];
    payload.forEach(function (payload) {
      var data = {
        x: payload.x,
        y: payload.y,
      };
      result.push(data);
    });
    state.getBookingReportByYear = result;
  },

  getEarningReportByYear(state, payload) {
    var result = [];
    payload.forEach(function (payload) {
      var data = {
        x: payload.x,
        y: payload.y,
      };
      result.push(data);
    });
    state.getEarningReportByYear = result;
  },
  getUpdateStatus(state, payload) {
    state.getUpdateStatus = payload;
  },
  getAllChargers(state, payload) {
    state.getAllChargers = payload.result;
  },
  getAllBanner(state, payload) {
    state.getAllBanner = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.bannerCount = payload.result.total;
  },
  getAllPrivateCharger(state, payload) {
    state.getAllPrivateCharger = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.privateChargerCount = payload.result.total;
  },
  getUserVehicle(state, payload) {
    state.user = payload.result;
  },
  getUserVehicleListFailure(state) {
    state.loading = false;
  },
  getUpdateVehicleMakeFailure(state) {
    state.loading = false;
  },
  getVehicleMakeListRequest(state) {
    state.loading = true;
  },
};

export const actions = {
  async getBanner({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await bannerService.getBanner(data).then(
      (response) => {
        commit("getAllBanner", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getPrivateCharger({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await bannerService.getPrivateCharger(data).then(
      (response) => {
        commit("getAllPrivateCharger", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async showBanner({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await bannerService.showBanner(data).then(
      (response) => {
        commit("getShowBanner", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async addOrUpdateBanner({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await bannerService.addOrUpdateBanner(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getAllChargersDetail({ commit }) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    await bannerService.getAllChargersDetail().then((response) => {
      commit("getAllChargers", response.data);
      //dispatch("alert/success", response.data.msg, { root: true });
    });
  },

  async deleteBanner({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await bannerService.deleteBanner(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getUsers({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await bannerService.getUsers(data).then((response) => {
      if (response.data.code == 200) {
        commit("getUser", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getMonthWiseBookingReport({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getVehicleMakeListRequest");
    await bannerService.getMonthWiseBooking(data).then((response) => {
      if (response.status == 200) {
        commit("getBookingReportByYear", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getMonthWiseEarningReport({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getVehicleMakeListRequest");
    await bannerService.getMonthWiseEarning(data).then((response) => {
      if (response.status == 200) {
        commit("getEarningReportByYear", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },
};

export const getters = {
  loading: (state) => state.loading,
  getAllBanner: (state) => state.getAllBanner,
  getAllPrivateCharger: (state) => state.getAllPrivateCharger,
  getShowBanner: (state) => state.getShowBanner,
  getUpdateStatus: (state) => state.getUpdateStatus,
  getAllChargers: (state) => state.getAllChargers,
  bannerCount: (state) => state.bannerCount,
  privateChargerCount: (state) => state.privateChargerCount,
  getAllUsers: (state) => state.getAllUsers,
  pagination: (state) => state.paginations,
  getBookingReportByYear: (state) => state.getBookingReportByYear,
  getEarningReportByYear: (state) => state.getEarningReportByYear,
};
